<template>
  <tr>
    <td>{{ demand.lastname }}</td>
    <td>{{ demand.firstname }}</td>
    <td>{{ demand.reference }}</td>
    <td>{{ demand.document_number }}</td>
    <td>{{ demand.document_type | capitalize }}</td>
    <td>{{ demand.visatype_name }}</td>
    <td>
      {{demand.state}}
    </td>
    <td>
      {{demand.matched}}
    </td>
    <td>{{ demand.demand_date | dateParse("YYYY-MM-DD HH:mm:ss") | dateFormat("DD/MM/YYYY HH:mm:ss") }}</td>
    <td>
      <button
        class="btn btn-info btn-circle"
        v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
        title="Voir les détails"
        @click="view(demand.id)"
      >
        <i class="fas fa-eye"></i>
      </button>
      <!-- <button
        class="action-btn action-btn-edit"
        title="Modifier"
        @click="edit(country.id)"
      >
        <i class="fas fa-edit"></i>
      </button>
      <button
        class="action-btn action-btn-delete"
        title="Supprimer"
        @click="remove(country.id)"
      >
        <i class="fas fa-trash"></i>
      </button> -->
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";

import { FETCH_DEMAND } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { P_READ_DEMAND } from "@/helpers/permissions";
import {DEMAND_STATUS_TRANSLATION} from "@/helpers/messages";


export default {
  props: {
    demand: { type: Object, required: true },
  },
  data(){
    return {
      P_READ_DEMAND,
      DEMAND_STATUS_TRANSLATION,
    }
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    // remove(id) {
    //   if (confirm("Voulez-vous vraiment supprimer cette ligne ?")) {
    //     this.$store.commit(SET_LOADING, true);

    //     this.$store
    //       .dispatch(DELETE_COUNTRY, id)
    //       .then(() => {
    //         this.$store.commit(SET_LOADING, false);
    //         alert("Suppression effectuée !");
    //       })
    //       .catch((error) => {
    //         this.$store.commit(SET_LOADING, false);
    //         alert("Impossible d'effectuer l'opération", error);
    //       });
    //   }
    // },
    // edit(id) {
    //   this.$store.commit(SET_LOADING, true);
    //   this.$store
    //     .dispatch(FETCH_COUNTRY, id)
    //     .then(() => {
    //       this.$store.commit(SET_LOADING, false);
    //       this.$router.push({ name: "country-edit" });
    //     })
    //     .catch(() => {
    //       this.$store.commit(SET_LOADING, false);
    //     });
    // },
    view(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_DEMAND, id)
        .then(() => {
          //this.$store.commit(SET_LOADING, false);
          this.$router.push({ name: "demands-backend-view" });
        })
        .catch(() => {
          //this.$store.commit(SET_LOADING, false);
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>

<style lang="scss">
</style>